module.exports = __webpack_public_path__ + "fonts/Didot.251039e6.ttf";